import { LeadStoreCreateResponseInterface } from 'common/data/lead/store/create/response.interface';
import { LeadEmailFormInputInterface } from 'common/module/lead/email/form/input.interface';

/**
 * Converts @response and @input into a new set of input
 */
export class LeadEmailFormInputAdapter {
  /**
   * Mapping "JSON API data[i].source.pointer" => "input name"
   */
  protected mapping: { [key: string]: keyof LeadEmailFormInputInterface } = {
    '/data/attributes/name': 'name',
    '/data/attributes/email': 'email',
    '/data/attributes/phone': 'phone',
    '/data/attributes/message': 'message',
    '/data/attributes/createAlert': 'createAlert',
    '/data/attributes/enquiry_type': 'enquiryType',
    '/data/attributes/captcha_token': 'captcha',
  };

  /**
   * Constructor
   */
  constructor(protected response: LeadStoreCreateResponseInterface, protected input: LeadEmailFormInputInterface) {}

  /**
   * Converts data into inputs
   */
  public getData(): LeadEmailFormInputInterface {
    // No errors
    if (!this.response.data.errors || this.response.data.errors.length === 0) {
      return this.input;
    }

    // Clone original inputs
    const input = {
      ...this.input,
    };

    // For each error
    this.response.data.errors.forEach((data) => {
      // Input name mapping
      const name = this.mapping[data.source.pointer];

      // Input name mapping not found
      if (!name) {
        return;
      }

      // Update input error message
      input[name].error = data.detail;
    });

    return input;
  }
}
